
/**
 * @imports
 */
import { Scope } from '@web-native-js/subscript';

/**
 * ---------------------------
 * The Contexts class
 * ---------------------------
 */				

export default Scope;
